let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h9R5C")).then(() => parcelRequire('imx7a'));